import React, { useState, useEffect } from 'react';
import { get } from '@api/v4/resources/conversion_presets';

import PresetTable from './preset_table';
import PresetForm from './preset_form';

import './styles/cropping.scss';

// import styles here because otherwise they don't work in dev environment
// these imports are not necessary for production environment
import "react-select/dist/react-select.min.css";
import "@components/common/select_react/react_select_styles";

export default () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const isCollection = Boolean(BF.fx.collection().key);
  const resourceType = isCollection ? 'collection' : 'brandfolder';
  const resourceFunc = isCollection ? BF.fx.collection : BF.fx.brandfolder;
  const { key, name: resourceName } = resourceFunc();

  const fetchPresets = async () => {
    setItems(await get({
      resourceType,
      resourceKey: key,
    }));
  };

  useEffect(() => {
    fetchPresets();
  }, []);

  const filteredItems = items.filter(({ name }) => name.includes(search));

  return (
    <div className="cropping">
      <h2>Manage Download Presets for {resourceName}</h2>
      <PresetForm
        onAddPreset={fetchPresets}
        resourceType={resourceType}
        resourceKey={key}
      />

      <input
        type="text"
        className="searchbar"
        value={search}
        onChange={({ target }) => setSearch(target.value)}
        placeholder={t("Search for download presets")}
      />

      <PresetTable
        items={filteredItems}
        onPresetChange={fetchPresets}
      />
    </div>
  );
};
